module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-inline position-relative"
  }, [_c('div', {
    staticClass: "d-inline"
  }, [(!_vm.value.changeStatusTo) ? _c('span', {
    staticClass: "lightest radius-normal px-2 py-1",
    class: _vm.getReservationState(_vm.value.status).cssClass
  }, [_vm._v("\n            " + _vm._s(_vm.getReservationState(_vm.value.status).label) + "\n            "), (_vm.getReservationState(_vm.value.status).allowChange && !_vm.disabled) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleShowOptions.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-arrow-bottom"
  })]) : _vm._e()]) : _c('span', {
    staticClass: "lightest radius-normal px-2 py-1",
    class: _vm.getReservationState(_vm.value.changeStatusTo).cssClass
  }, [_vm._v("\n            " + _vm._s(_vm.getReservationState(_vm.value.changeStatusTo).label) + "\n            "), (_vm.getReservationState(_vm.value.changeStatusTo).allowChange) ? _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleShowOptions.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "mr-0 ml-2 ico ico-arrow-bottom"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.optionsHolderOpen) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.toggleShowOptions),
      expression: "toggleShowOptions"
    }],
    staticClass: "optionsHolder radius-normal p-2 border-light"
  }, _vm._l((_vm.getAllReservationStates), function(option) {
    return _c('div', {
      key: option.id
    }, [(option.isOption) ? _c('button', {
      staticClass: "lightest radius-normal border-0 w-100 px-2 py-1 mb-2 text-center pointer",
      class: option.cssClass,
      attrs: {
        "disabled": _vm.statusBtnValidation(option)
      },
      on: {
        "click": function($event) {
          return _vm.selectOption(option, option.code)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n            ")]) : _vm._e()])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330dad40"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/reservation/changeStatusBtn.vue
// module id = 1576
// module chunks = 0